import React from 'react';
import { Field } from 'react-form';
import ReactBootstrapSlider from 'react-bootstrap-slider';
import InfoButton from '../../InfoButton';
import { ageSliderDictionary } from '../../../utils/constants';

const AgeRangeSliderSmall = props => (
    <Field field={props.field} validate={props.validate}>

        { fieldApi => {
            const { onChange, onBlur, slideStop, field, validate, hoverText, 'data-testid': dataTestId, ...rest } = props;
            const { value, setValue, setTouched } = fieldApi;

            const inputProps = {
                ...rest,
                value: value || [],
                change: e => {
                    setValue(e.target.value);
                    if (onChange) {
                        onChange(e.target.value, e);
                    }
                },
                onBlur: e => {
                    setTouched();
                    if (onBlur) {
                        onBlur(e);
                    }
                },
                slideStop: e => {
                    if (slideStop) {
                        slideStop(e, setValue);
                    }
                },
            };

            const ageDisplay = () => {
                const startRange = value[0];
                const endRange = value[1];
                if (startRange === 0 && endRange === Object.keys(ageSliderDictionary).length - 1) {
                    return 'All';
                } if (startRange === endRange && startRange === 0) {
                    return `${ageSliderDictionary[1]} and Under`;
                } if (startRange === endRange && endRange === Object.keys(ageSliderDictionary).length - 1) {
                    return `${ageSliderDictionary[endRange - 1]} and Over`;
                } if (startRange === endRange) {
                    return `Age ${ageSliderDictionary[startRange]} Only`;
                } if (startRange === 0) {
                    return `${ageSliderDictionary[endRange]} and Under`;
                } if (endRange === Object.keys(ageSliderDictionary).length - 1) {
                    return `${ageSliderDictionary[startRange]} and Over`;
                }
                return `${ageSliderDictionary[startRange]} to ${ageSliderDictionary[endRange]}`;
            };

            return (
                <div className="form-group form-group-xl help slider-small slider-gray" data-testid={dataTestId || undefined}>
                    <label htmlFor="name" className="mb10">
                        Age
                        {hoverText && <InfoButton hoverText={hoverText} />}
                        <span className="utr text-dark" data-testid={dataTestId && `${dataTestId}.value`}>{ageDisplay()}</span>
                    </label>
                    <div className="wrapper" data-testid={dataTestId && `${dataTestId}.slider`}>
                        <ReactBootstrapSlider
                            {...inputProps}
                            startValue={[0, Object.keys(ageSliderDictionary).length - 1]}
                            range={true}
                            min={0}
                            max={Object.keys(ageSliderDictionary).length - 1}
                            step={1}
                        />
                    </div>
                </div>
            );
        }}
    </Field>
);

export default AgeRangeSliderSmall;
